import { render, staticRenderFns } from "./QnaDetail.vue?vue&type=template&id=ba2bf5ac&scoped=true&"
import script from "./QnaDetail.vue?vue&type=script&lang=js&"
export * from "./QnaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2bf5ac",
  null
  
)

export default component.exports